<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="backButtonRoute"
    ref="customer-statement"
    :data-model="dataModel"
    :backRouteAppend="undefined"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    class="customer-statement"
    :refreshDataGridProp="refreshDataGrid"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { getFactorByCode } from "../../_store/helpers";
import { CustomerStatementService } from "../../_services/api/customers/customer-statement.service";
import { UserService } from "../../_services/api/settings/user/user.service";
// import CheckBox from "devextreme/ui/check_box";
// import { mapGetters } from "vuex";
// import { CustomerStatementService } from "../../_services/api/customers/customer-statement-service";
// import { CustomerService } from "../../_services/api/customers/customer.service";
// import { FactorService } from "../../_services/api/sales/factor.service";
// import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
// import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
// import { CustomerInvoiceService } from "../../_services/api/customers/customer-invoice.service";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      dataModel: {
        StatementType: undefined,
        ActivityStartDate: undefined, // Start Date
        StatementDate: undefined, // End Date
        CustomerTypeCode: undefined,
        CustomerGroupCode: undefined,
        Terms: undefined,
        EmailTo: undefined,
        BillToCustomerCode: undefined,
        GroupByBillTo: false,
        AgeByPeriod: "Month",
        ResendAll: false,
        ResendFailed: false,
      },
      reload: false,
      validationSummary: [],
      serverError: {},
      model: undefined,
      localData: [],
      refreshDataGrid: false,
    };
  },

  async created() {},
  async mounted() {
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    backButtonRoute() {
      return "/customer-statement";
    },

    getScreenJson() {
      var screenJson = {
        title: "Customer Statement",
        endpoint: { primary: undefined },
        gridData: {
          gridOptions: {
            dataSource:
              // this.baseView.mode == "create"
              //   ?
              {
                // serverPaging: false,
                allowGrouping: false,

                localDataList: true,
                items: this.localData,
                // postProcessCallback:
                //   this.createCustomerStatementDetailPostProcess,
              },
            // : {
            //     endpoint: "CustomerStatementRunDetailList",
            //     filter:
            //       this.baseView.mode == "create"
            //         ? ["RunId", "=", 0]
            //         : ["RunId", "=", parseInt(this.baseView.id)],
            //     serverPaging: true,
            //     allowGrouping: false,
            //     // postProcessCallback:
            //     //   this.createCustomerStatementDetailPostProcess,
            //   },
            options: {
              wordWrapEnabled: false,
              selectionMode:
                this.baseView.mode != "review" ? "multiple" : "none",
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: false,
          },
          columns: [
            // {
            //   screenField: "CheckInclude",
            //   allowEditing: false,
            //   defaultValue: false,
            //   // valueChangeCallBack: this.checkBoxValueChange,
            //   allowHiding: false,
            //   showInColumnChooser: false,
            //   fixed: true,
            //   fixedPosition: "left",
            //   label: "",
            //   width: 50,
            //   minWidth: 50,
            // },
            {
              screenField: "Customer",
            },
            {
              screenField: "Email",
              dataField: "CustomerContactEmail",
            },
            {
              screenField: "Comments",
              dataField: "Comment",
              label: "Message",
            },
            {
              screenField: "Email",
              dataField: "EmailStatus",
              label: "Status",
              cellTemplate:
                this.baseView.mode != "create" ? "Status" : undefined,
            },
          ],

          valueChangedEventListners: [
            // {
            //   dataField: "FXAllocationAmount",
            //   listner: (e, lineData) => {
            //     lineData.data.FXAllocationAmount = e.value;
            //     lineData.data.FXAllocation = e.value;
            //     this.mergeWithReviewView(
            //       lineData.data.FXAllocationAmount == 0 ? false : true,
            //       lineData.data
            //     );
            //   },
            // },
          ],
        },
        // footerData: {
        //   footerItems: [],
        // },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerToolbar: {
            save: true,
            saveIcon: "fa fa-paper-plane",
            saveCallback: this.saveCustomerStatement,
            screenName: "Customer Statement",
            pdf: false,
            email: false,
            audit: false,
            status: false,
            notes: false,
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "StatementType",
                      editorOptions: {
                        showClearButton: true,
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                        onValueChanged: (e) => {
                          this.onStatementTypeChanged(e);
                        },
                      },
                      required: true,
                    },
                    {
                      screenField: "DateIn",
                      dataField: "ActivityStartDate",
                      label: {
                        text: "Start Date",
                      },
                      editorOptions: {
                        allowUpdate:
                          this.baseView.mode == "create"
                            ? this.dataModel.StatementType == "Outstanding"
                              ? false
                              : true
                            : false,
                        onValueChanged: (e) => {
                          this.onStartDateChange(e);
                        },
                      },
                      required: true,
                      visible: this.dataModel.StatementType != "Outstanding",
                    },
                    {
                      screenField: "DateIn",
                      dataField: "StatementDate",
                      label: {
                        text: "End Date",
                      },
                      editorOptions: {
                        min:
                          this.dataModel.StatementType != "Outstanding"
                            ? this.dataModel.ActivityStartDate
                            : undefined,
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                      required: true,
                    },
                    {
                      screenField: "CustomerType",
                      editorOptions: {
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                        showClearButton: true,
                      },
                      dataSourceConfig: {
                        endpoint: "api/CustomerType",
                        sort: {
                          selector: "Code",
                          asc: true,
                        },
                        filter: [["Inactive", "=", "N"]],
                      },
                    },

                    {
                      dataField: "Generate",
                      label: {
                        text: "",
                        visible: false,
                      },
                      // cssClass: "generate-btn",
                      editorType: "dxButton",
                      editorOptions: {
                        validationGroup: "gc-header-form",
                        onClick: async (e) => {
                          if (e) this.generateData();
                          else return;
                        },
                        text: "Generate",
                        type: "default",
                        rtlEnabled: false,
                        // useSubmitBehavior: true,
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                      visible: this.baseView.mode == "create",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "CustomerGroup",
                      editorOptions: {
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                        showClearButton: true,
                      },
                      dataSourceConfig: {
                        endpoint: "api/CustomerGroup",
                        sort: {
                          selector: "Code",
                          asc: true,
                        },
                        filter: [["Inactive", "=", "N"]],
                      },
                    },
                    {
                      screenField: "Terms",
                      editorOptions: {
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                    },
                    {
                      screenField: "EmailTo",
                      editorOptions: {
                        showClearButton: true,
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                    },
                    {
                      screenField: "Customer",
                      editorOptions: {
                        showClearButton: true,
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                      visible: this.dataModel.EmailTo == "Customer",
                    },
                    {
                      screenField: "BillToCustomer",
                      editorOptions: {
                        showClearButton: true,
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                      visible: this.dataModel.EmailTo == "Bill to Customer",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "GroupByBillto",
                      dataField: "GroupByBillTo",
                      editorOptions: {
                        allowUpdate:
                          this.baseView.mode == "create" ? true : false,
                      },
                    },
                    {
                      itemType: "group",
                      caption: "Aged by",
                      cssClass: "aged-by",
                      items: [
                        {
                          dataField: "AgeByPeriod",
                          label: {
                            text: "Aged by",
                            visible: false,
                          },
                          editorType: "dxRadioGroup",
                          editorOptions: {
                            layout: "horizontal",
                            items: [
                              {
                                value: "Month",
                              },
                              {
                                value: "Terms",
                              },
                            ],
                            valueExpr: "value",
                            displayExpr: "value",

                            allowUpdate:
                              this.baseView.mode == "create" ? true : false,
                          },
                        },
                      ],
                    },
                    {
                      screenField: "ResendAll",
                      visible: this.baseView.mode != "create",
                      editorOptions: {
                        onValueChanged: (e) => {
                          this.selectAllRows(e.value);
                        },
                      },
                    },
                    {
                      screenField: "ResendFailed",
                      visible: this.baseView.mode != "create",
                      editorOptions: {
                        onValueChanged: (e) => {
                          this.selectFailedRows(e.value);
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // createModeIsEditMode: true,
            primary: {
              primary: {
                dataField:
                  this.baseView.mode == "create" ? undefined : undefined,
                text:
                  this.baseView.mode == "create"
                    ? "Create Customer Statement"
                    : "Statement Run Review",
              },
              secondary: {
                dataField:
                  this.baseView.mode == "create" ? undefined : undefined,
                text: this.baseView.mode == "create" ? undefined : undefined,
              },
            },
            secondary: {},
          },
        },
      };
    },
  },
  methods: {
    onStatementTypeChanged(e) {
      if (e.value == "Activity")
        this.dataModel.ActivityStartDate = this.dataModel.StatementDate;
    },
    onStartDateChange(e) {
      if (this.dataModel.ActivityStartDate > this.dataModel.StatementDate)
        this.dataModel.StatementDate = e.value;
    },
    selectFailedRows(value) {
      var items =
        this.$refs["customer-statement"].$refs[
          "transactionGrid"
        ].getDataSource();

      var index = [];
      items.forEach((element, i) => {
        if (element.EmailStatus == "F") index.push(i);
      });
      var dataGrid =
        this.$refs["customer-statement"].$refs[
          "transactionGrid"
        ].getGridInstance();

      if (value) {
        this.dataModel.ResendAll = false;
        this.$refs["customer-statement"].$refs[
          "gc-header-form-component"
        ].$refs["gc-header-form"].formRepaint();
        dataGrid.selectRowsByIndexes(index);
      } else dataGrid.deselectAll();
    },
    selectAllRows(value) {
      var dataGrid =
        this.$refs["customer-statement"].$refs[
          "transactionGrid"
        ].getGridInstance();

      if (value) {
        // if(this.dataModel.ResendFailed)
        this.dataModel.ResendFailed = false;
        this.$refs["customer-statement"].$refs[
          "gc-header-form-component"
        ].$refs["gc-header-form"].formRepaint();
        dataGrid.selectAll();
      } else dataGrid.deselectAll();

      // console.log("XX ", this.dataModel);
    },
    async saveCustomerStatement() {
      if (this.dataModel.ResendAll) {
        let confirmResendAll = await this.$confirm(
          "Do you want to resend to all entries ?",
          "Resend All"
        );
        if (!confirmResendAll) return;
      }

      if (this.dataModel.ResendFailed) {
        let confirmResendFailed = await this.$confirm(
          "Do you want to resend to Failed entries only ?",
          "Resend Failed"
        );
        if (!confirmResendFailed) return;
      }

      // return;

      var selectedRows =
        this.$refs["customer-statement"].$refs[
          "transactionGrid"
        ].getSelectedRowsData();

      if (selectedRows.length == 0) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: `Customer Statement has no detail. Please add one or more lines before attempting to send the statements again.`,
        });
        return;
      }

      var payload = {
        RunId: this.baseView.id ? parseInt(this.baseView.id) : 0,
        StatementDate: this.dataModel.StatementDate
          ? this.dataModel.StatementDate.toSaveDate()
          : undefined,
        StatementType: this.dataModel.StatementType,
        ActivityStartDate: this.dataModel.ActivityStartDate
          ? this.dataModel.ActivityStartDate.toSaveDate()
          : undefined,
        CreatedBy: UserService.getUsername(),
        GroupByBillTo: this.dataModel.GroupByBillTo,
        AgeByPeriod: this.dataModel.AgeByPeriod == "Terms" ? false : true,
        CustomerStatementRunDetails: selectedRows.map((i) => {
          return {
            RunId: this.baseView.id ? parseInt(this.baseView.id) : 0,
            CustomerContactCode: i.CustomerContactCode,
            CustomerCode: i.CustomerCode,
            EmailStatus: "",
            CreatedBy: UserService.getUsername(),
          };
        }),
      };

      // return;

      this.setLoading = true;
      await CustomerStatementService.saveCustomerStatement(payload)
        .then((res) => {
          this.setLoading = false;
          if (res)
            this.$notify(`Customer Statements Successfully Sent`, "success");

          if (res.data.RunId) {
            this.setIgnoreRouteChangeConfirmation();
            this.reload = true;
            this.loaded = false;
            this.$router
              .push({
                path: `/customer-statement/review/${
                  this.baseView.id ? this.baseView.id : res.data.RunId
                }`,
              })
              .then(() => {
                this.initialized();
              });
          }
        })
        .catch((err) => {
          this.setLoading = false;
          if (err)
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Failed",
            });
        });
    },
    async initialized() {
      // this.reload = false;
      this.setLoading = true;

      if (this.baseView.mode == "create") {
        await this.$store.dispatch(
          "screenFactors/getFactors",
          [660] // , 65, 66]
        );
        this.dataModel.StatementType = getFactorByCode(660).Factorc;
        this.dataModel.ActivityStartDate = new Date();
        this.dataModel.StatementDate = new Date();
      }

      if (this.baseView.mode != "create") {
        await CustomerStatementService.getByRunId(parseInt(this.baseView.id))
          .then((res) => {
            this.dataModel = res.data.value[0];

            if (this.dataModel.AgeByPeriod)
              this.dataModel.AgeByPeriod = "Month";
            else this.dataModel.AgeByPeriod = "Terms";

            this.dataModel.StatementDate = new Date(
              this.dataModel.StatementDate
            );
            this.dataModel.ActivityStartDate = new Date(
              this.dataModel.ActivityStartDate
            );
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });

        await CustomerStatementService.getDetailsListData({
          filter: "RunId eq " + parseInt(this.baseView.id),
        })
          .then((res) => {
            // this.setLoading = false;
            this.localData = res.data.value;
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });

        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      } else {
        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      }
    },
    async generateData() {
      this.setLoading = true;
      this.refreshDataGrid = true;
      var filter = "RunId eq 0";
      if (this.dataModel.CustomerTypeCode) {
        filter = filter + " and ";
        filter =
          filter + `CustomerType eq '${this.dataModel.CustomerTypeCode}'`;
      }
      if (this.dataModel.CustomerGroupCode) {
        filter = filter + " and ";
        filter =
          filter + `CustomerGroup eq '${this.dataModel.CustomerGroupCode}'`;
      }
      if (this.dataModel.Terms) {
        filter = filter + " and ";
        filter = filter + "Terms eq " + this.dataModel.Terms;
      }

      if (
        this.dataModel.EmailTo == "Bill to Customer" &&
        this.dataModel.BillToCustomerCode
      ) {
        filter = filter + " and ";
        filter =
          filter +
          `BillToCustomerCode eq '${this.dataModel.BillToCustomerCode}'`;
      }

      if (this.dataModel.EmailTo == "Customer" && this.dataModel.CustomerCode) {
        filter = filter + " and ";
        filter = filter + `CustomerCode eq '${this.dataModel.CustomerCode}'`;
      }
      await CustomerStatementService.getDetailsListData({
        filter: filter,
      })
        .then((res) => {
          this.setLoading = false;
          this.localData = res.data.value;

          setTimeout(() => {
            this.refreshDataGrid = false;
          }, 100);
        })
        .catch((err) => {
          if (err) this.refreshDataGrid = false;
          this.setLoading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
